import React, { useEffect, useRef } from 'react'
import './single-page.scss'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import AllianceLogo from '../../../assets/images/alliance-logo.png'
import { IoChevronBack } from "react-icons/io5";
import { HiStatusOffline, HiStatusOnline } from "react-icons/hi";
import { toast } from '../../../redux/features/user/systemSlice'
import { LuHistory } from 'react-icons/lu'
import { MdOutlineSpaceDashboard, MdWindow } from 'react-icons/md'
import { YYYYMMFormat } from '../../../assets/javascript/date-helper'



function WarehousePage({ pageHead, children }) {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { internet } = useSelector((state) => state.systemInfo)
    const lastScrollTop = useRef(0);
    const navbarRef = useRef(null);
    // eslint-disable-next-line
    const [searchParams, setSearchParams] = useSearchParams()

    useEffect(() => {
        const onScroll = () => {
            let currentScrollPos = window.pageYOffset || document.documentElement.scrollTop;

            if (currentScrollPos > lastScrollTop.current) {
                // Scroll Down, hide the navbar
                navbarRef.current.style.top = "-80px";
            } else {
                // Scroll Up, show the navbar
                navbarRef.current.style.top = "0";
            }

            lastScrollTop.current = currentScrollPos;
        };

        window.addEventListener("scroll", onScroll);

        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (

        <div className="single-page-body">
            <div className="single-page-header-div" ref={navbarRef}>
                <div className="border">
                    <div className="left" onClick={() => navigate(-1)}>
                        <IoChevronBack />
                        <img src={AllianceLogo} alt='logo' />
                        <div className='head-text'>
                            <h3>Alliance</h3>
                            <p>Sales Warehouse App</p>
                        </div>
                    </div>
                    <div className="right">
                        <div className="round-icon-button" title='App list' onClick={() => window.location.href = 'https://worker.alliancedev.in/?page=home'}>
                            <MdWindow />
                        </div>
                        <div className="round-icon-button" style={{ cursor: "auto", color: !internet && 'red' }}
                            title={internet ? 'Online' : 'Offline'} onClick={() => dispatch(toast.push.info({
                                message: internet ? 'You are in Online' : 'You are in Offline',
                                icon: internet ? 'HiStatusOnline' : 'HiStatusOffline'
                            }))}>
                            {internet ? <HiStatusOnline /> : <HiStatusOffline />}
                        </div>
                    </div>
                </div>
            </div>

            <div className="single-page-body-div">
                <div className="page-container">
                    <div className="page-title-div">
                        <div className="left">
                            <h3>{pageHead?.title}</h3>
                            <p>{pageHead?.desc}</p>
                        </div>
                        <div className="right">
                            {pageHead?.right}
                        </div>
                    </div>
                    <div className="page-content-div">
                        {children}
                    </div>
                </div>
            </div>

            <div className="single-page-menu-div">
                <div className="menu-div" style={{ gridTemplateColumns: "1fr 1fr" }}>
                    <div className={searchParams.get('page') === 'pending' ? "item-div active-item" : "item-div"} onClick={() => navigate('/warehouse?page=pending')}>
                        <MdOutlineSpaceDashboard />
                        <p>Pending List</p>
                    </div>
                    <div className={searchParams.get('page') === 'history' ? "item-div active-item" : "item-div"} onClick={() => navigate(`/warehouse/history?page=history&date=${YYYYMMFormat(new Date())}`)}>
                        <LuHistory />
                        <p>History</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WarehousePage